import { render, staticRenderFns } from "./ModalConfirmCFOP.vue?vue&type=template&id=20d80530&scoped=true&"
import script from "./ModalConfirmCFOP.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmCFOP.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmCFOP.vue?vue&type=style&index=0&id=20d80530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d80530",
  null
  
)

export default component.exports